import { FC, useEffect, useState } from "react";
import { MemberHeader } from "../../parts/MemberHeader";
import { Helmet } from "react-helmet";

function toEmbedUrl(url: string): string {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) {
      const id = u.pathname.replace("/", "");
      return `https://www.youtube.com/embed/${id}`;
    }
    if (u.hostname.includes("youtube.com")) {
      const v = u.searchParams.get("v");
      if (v) return `https://www.youtube.com/embed/${v}`;
      const parts = u.pathname.split("/").filter(Boolean);
      if (parts[0] === "shorts" && parts[1]) {
        return `https://www.youtube.com/embed/${parts[1]}`;
      }
    }
  } catch {}
  return url;
}

export const MemberVideosPage: FC = () => {
  const [urls, setUrls] = useState<string[] | undefined>(undefined);

  useEffect(() => {
    const load = async () => {
      setUrls([
        "https://youtu.be/SCXOALcW2Ik",
        "https://youtu.be/JKOqDLCM_NA",
        "https://youtu.be/0z6BvEWBFQY",
        "https://youtu.be/nsVjD4xQrBU",
        "https://youtu.be/c2UBp3H58sg",
        "https://youtu.be/bPUuEaFjPUI",
        "https://youtu.be/Oufyb64Kk5k",
        "https://youtu.be/eVqQys3rMcY",
        "https://youtu.be/HRJH9_ReDyI",
        "https://youtu.be/kjFtPj-qado",
        "https://youtu.be/78i4iImyCZI",
        "https://youtu.be/xHIaAetM_M4",
        "https://youtu.be/2uxsMW6ZRnc",
      ]);
    };
    load();
  }, []);

  return (
    <>
      <MemberHeader />
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>メンバー動画</title>
      </Helmet>

      <div className="margin-auto max-w-6xl px-3 sm:px-6 mt-5 mb-14">
        {urls === undefined && (
          <div className="text-sm text-gray-500">読み込み中…</div>
        )}
        {urls !== undefined && urls.length === 0 && (
          <div className="text-sm text-gray-500">動画がまだありません</div>
        )}
        {urls && urls.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {urls.map((u, idx) => (
              <div
                key={idx}
                className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow duration-150 overflow-hidden"
              >
                <div className="bg-black" style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
                  <iframe
                    src={toEmbedUrl(u)}
                    title={`video-${idx + 1}`}
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                    frameBorder={0}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default MemberVideosPage;
